import React from 'react';

function PrivacyIOS() {
  return (
    <div className='max-w-2xl mx-auto p-4'>
      <h2 className='text-3xl font-bold mb-4 mt-4'>Privacy Policy</h2>

      <section className='mb-8'>
        <h3 className='text-xl font-bold mb-2'>1. Introduction</h3>
        <p>
          Welcome to Pikchar. This Privacy Policy explains how we collect, use,
          disclose, and safeguard your information when you use our iOS
          application, Pikchar ("App"). By downloading, installing, or using the
          App, you agree to the collection and use of information in accordance
          with this policy.
        </p>
      </section>

      <section className='mb-8'>
        <h3 className='text-xl font-bold mb-2'>2. Information We Collect</h3>
        <p>
          We collect the following personal information from you when you create
          an account and use the App:
        </p>

        <ul className='list-disc ml-6 mb-8'>
          <li>Email Address</li>
          <li>First Name</li>
          <li>Last Name</li>
          <li>User ID</li>
        </ul>

        <p>
          Additionally, certain non-personal information may be collected
          automatically by Apple’s APIs or our backend services, such as device
          type, app version, and usage analytics.
        </p>
      </section>

      <section className='mb-8'>
        <h3 className='text-xl font-bold mb-2'>
          3. How We Use Your Information
        </h3>
        <p>The information we collect is used for the following purposes:</p>

        <ul className='list-disc ml-6 mb-8'>
          <li>
            <strong>Account Creation and Management:</strong> Your email,
            name, and user ID help us create and manage your Pikchar account.
          </li>
          <li>
            <strong>App Functionality:</strong> Your data supports core features
            such as personalized content, user profile management, and playback
            history.
          </li>
          <li>
            <strong>Communication:</strong> We may use your email to send
            important updates, notifications, or promotional content. You may
            opt-out of promotional emails anytime.
          </li>
          <li>
            <strong>Improving App Performance:</strong> Anonymous analytics help
            us improve stability, fix bugs, and enhance user experience.
          </li>
        </ul>
      </section>

      <section className='mb-8'>
        <h3 className='text-xl font-bold mb-2'>
          4. Information Sharing and Disclosure
        </h3>
        <p>
          We do not sell or trade your personal data. Your information is only
          shared as described below:
        </p>

        <ul className='list-disc ml-6 mb-8'>
          <li>
            <strong>Service Providers:</strong> Trusted third-party providers
            may receive access to your information strictly for services like
            authentication, analytics, and app infrastructure.
          </li>
          <li>
            <strong>Apple Services:</strong> Certain anonymized data may be
            processed by Apple systems such as iCloud or Apple’s analytics
            services depending on your device settings.
          </li>
          <li>
            <strong>Legal Compliance:</strong> We may disclose information if
            required by law, regulation, or legal processes.
          </li>
        </ul>
      </section>

      <section className='mb-8'>
        <h3 className='text-xl font-bold mb-2'>
          5. Security of Your Information
        </h3>
        <p>
          We use industry-standard security measures to protect your personal
          information. However, no electronic transmission or storage system is
          completely secure, and we cannot guarantee absolute protection.
        </p>
      </section>

      <section className='mb-8'>
        <h3 className='text-xl font-bold mb-2'>6. Your Privacy Rights</h3>
        <p>
          Depending on your region, you may have rights related to your personal
          information, including:
        </p>

        <ul className='list-disc ml-6 mb-8'>
          <li>
            <strong>Access and Correction:</strong> Request access to your
            personal data or request corrections.
          </li>
          <li>
            <strong>Deletion:</strong> Request deletion of your information,
            subject to legal and operational requirements.
          </li>
          <li>
            <strong>Email Preferences:</strong> Opt-out of promotional emails
            anytime.
          </li>
        </ul>
      </section>

      <section className='mb-8'>
        <h3 className='text-xl font-bold mb-2'>
          7. Changes to This Privacy Policy
        </h3>
        <p>
          We may update this Privacy Policy periodically. Updated versions will
          be posted on this page along with a revised effective date. You are
          encouraged to review the policy from time to time.
        </p>
      </section>

      <section className='mb-8'>
        <h3 className='text-xl font-bold mb-2'>8. Contact Us</h3>
        <p>
          For questions or concerns about this Privacy Policy or your data
          rights, contact us at:
        </p>
        <p>
          <strong>Email:</strong> pikcharxdynamix@gmail.com
        </p>
      </section>
    </div>
  );
}

export default PrivacyIOS;
